module.exports = __webpack_public_path__ + "static/media/fondo-resources.c500b28d.png";